import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetMarketCodeList, Status } from '../../services/apiTypes';
import { getMarketCodeList as getMarketCodeListAPI } from './api';
import { isGetMarketCodeList } from '../../_utils/typeGuardUtils';

interface MarketState {
  status: Status;
  marketCodeList: GetMarketCodeList;
}

const initialState: MarketState = {
  status: 'idle',
  marketCodeList: [],
};

export const getMarketCodeList = createAsyncThunk(
  'marketCodeList/getMarketCodeList',
  async (_, { rejectWithValue }) => {
    try {
      return await getMarketCodeListAPI();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const marketCodeListSlice = createSlice({
  name: 'marketCodeListData',
  initialState,
  reducers: {
    resetMarketCode: (state) => {
      state.marketCodeList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMarketCodeList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getMarketCodeList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetMarketCodeList(action.payload)) {
          state.marketCodeList = action.payload;
        }
      })
      .addCase(getMarketCodeList.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { resetMarketCode } = marketCodeListSlice.actions;
export default marketCodeListSlice.reducer;
